import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {useSelector} from 'react-redux'
import {getChatName} from 'ag-common/tools/chat'
import ArrowLeft from '#components/svg/icons/ArrowLeft'
import Headline from '#components/a/Headline'

function ChatListItem({id, isSelected, onSelect}) {
  const chat = useSelector(state => state.chat.chats[id])
  const name = getChatName(chat, i18n.t('unknown_user'))
  const lastMessage = useSelector(state => state.chat.chats[id].lastMessage)
  const hasNewActivities = useSelector(state => state.chat.chats[id].hasNewActivities)

  let classNames = isSelected ? 'chat-list-item chat-list-item__selected' : 'chat-list-item'
  if (hasNewActivities) classNames += ' has-updates'
  return (
    <button type="button" className={classNames} onClick={onSelect} data-chatname={name}>
      <div>
        <Headline importance={6} modifier="fragment" text={name} />
        <div className="chat-list-item__subtitle">
          {hasNewActivities && <div className="chat-list-item__update-indicator" data-testid="update-indicator" />}
          {lastMessage && <div className="chat-last-message">{lastMessage}</div>}
        </div>
      </div>
      <ArrowLeft />
    </button>
  )
}

ChatListItem.propTypes = {
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
}

export default ChatListItem
